const location = window.location

// global var shared with search-typeahead.js
let searchAheadElements = window.searchAheadElements

export const generalSearch = {
  baseUrlG: null,
  init: function (url) {
    this.baseUrlG = url
  },
  search: function (query, type, language) {
    const params = []
    if (query) params.push("query=" + encodeURIComponent(query))
    if (type) params.push("type=" + encodeURIComponent(type))
    if (language) params.push("language=" + encodeURIComponent(language))
    params.push("c=global")

    const url = this.baseUrlG + "?" + params.join("&")

    location.href = url
  },
}

function domHasLoaded() {
  generalSearch.init(document.getElementById("SearchResultsPageLink")?.value)
  document.querySelector(".search__field")?.addEventListener("submit", function (event) {
    if (searchAheadElements?.classList.contains("active")) {
      const searchAheadElement = searchAheadElements.querySelector(".active a.js--search-ahead-link")
      const tempElement = document.createElement("a")
      tempElement.href = searchAheadElement?.href
      const url = window.location.origin + tempElement.pathname
      location.href = url
      return false
    } else {
      const query = this.querySelector('input[type="text"]')?.value
      return PerformGeneralSearch(query)
    }
  })
  document.querySelector(".general-search-panel__field")?.addEventListener("submit", function () {
    const query = this.querySelector("input.js--general-search-panel-field")?.value
    return PerformGeneralSearch(query)
  })
  document.querySelector("form.general-search-panel__field a.button")?.addEventListener("click", function () {
    this.parentElement.submit()
  })
  setupProductSearchDOM()
}

function PerformGeneralSearch(query) {
  if (query === "") {
    return true
  }
  generalSearch.search(query, document.getElementById("PageTypeContainer")?.value)
  return false
}

export function setupProductSearchDOM() {
  const form = document.querySelector("[data-tiles-search-form]")
  form?.removeEventListener("submit").addEventListener("submit", function () {
    let url = ""
    if (searchAheadElements?.classList.contains("active")) {
      const searchAheadElement = searchAheadElements.querySelector(".active a.js--search-ahead-link")
      url = window.location.origin + searchAheadElement.href
      location.href = url
      return false
    } else {
      const searchField = this.querySelector('input[type="text"]')
      const searchPage = searchField?.getAttribute("data-searchurl")
      url = window.location.origin + searchPage + "?q=" + searchField?.value
      location.href = url
      return false
    }
  })
}

if (document.readyState !== "loading") {
  domHasLoaded()
} else {
  document.addEventListener("DOMContentLoaded", domHasLoaded)
}
